import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: null,
  artworkData: null,
};

const ArtworkReducer = createSlice({
  name: "Artwork",
  initialState,
  reducers: {
    uploadArtworkRequest: (state) => {
      state.isLoading = true;
      state.error = null;
      state.artworkData = null;
    },
    uploadArtworkSuccess: (state, action) => {
      state.isLoading = false;
      state.artworkData = action.payload;
    },
    uploadArtworkFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    clearArtworkState: (state) => {
      state.isLoading = false;
      state.error = null;
      state.artworkData = null;
    },
    resetArtwork: (state) => {
      state.isLoading = false;
      state.artworkData = null;
      state.error = null;
    },
  },
});

export const {
  uploadArtworkRequest,
  uploadArtworkSuccess,
  uploadArtworkFailure,
  clearArtworkState,
  resetArtwork,
} = ArtworkReducer.actions;

export default ArtworkReducer.reducer;
